import React from "react";

import BigIMG from "../Assets/illustration-incentives.png";

import "./Hero.scss";

const Hero = () => {
  return (
    <section className="join-hero">
      <div className="large-container">
        <div className="w-100 py-5 d-flex flex-column flex-xl-row justify-content-between align-items-center">
          <div className="order-2 order-xl-1 d-flex align-items-center align-items-xl-start justify-content-start flex-column gap-3">
            <span className="top-banner font-size-16 font-pnm color-white">
              🔥 Over 12.500 people joined the last month
            </span>
            <span className="font-size-80 font-pnb color-white lh-1">Welcome to ZiXXar</span>
            <span className="font-size-24 font-pnr color-medium-gray text-center text-xl-start">
              In order for your application to be approved, you must be selected by an existing user
              and assigned to their team. The more details you include, the better your chances to
              be quickly selected in order to register in the platform.
            </span>
          </div>
          <img
            src={BigIMG}
            alt="incentive"
            className="order-1 order-xl-2 pt-3 img-fluid hero-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
